import { RefObject, useCallback, useEffect, useState } from 'react';

export const useHorizontalOverflow = (ref: RefObject<HTMLDivElement>) => {
  const [hasOverflow, setHasOverflow] = useState(false);

  const checkOverflow = useCallback(() => {
    if (ref.current) {
      const { scrollWidth, clientWidth } = ref.current;
      const hasOverflow = scrollWidth > clientWidth;
      const isGradientApplicable =
        hasOverflow && ref.current.scrollLeft < scrollWidth - clientWidth - 1;
      setHasOverflow(isGradientApplicable);
    }
  }, [ref]);

  useEffect(() => {
    if (!ref.current) return;

    ref.current.addEventListener('scroll', checkOverflow);
    window.addEventListener('resize', checkOverflow);

    checkOverflow();

    return () => {
      window.removeEventListener('resize', checkOverflow);
      ref.current?.removeEventListener('scroll', checkOverflow);
    };
  }, [checkOverflow]);

  return { hasOverflow };
};
